<template>
  <div id="HomePage">
    <!-- downLoad -->
    <div id="downLoad" class="container-fuild">
      <div class="row downLoad-container">
        <div class="col-xs-12 col-sm-12 col-md-6 wow slideInLeft">
          <img class="img-responsive" src="@/assets/img/img1.png" alt="role">
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 downLoadDescribe">
          <h2 class="downLoad-title">
            Tongits Land <br/>- Special Made for Filipinos
          </h2>
          <div class="download-intro">
            <ul class="download-ul">
              <li>"Play Tongits Land & Earn PHP" Activity</li>
              <li>Play games to win PHP! </li>
              <li>Directly to GCash Acct！</li>
              <li>Join this activity, share 1,000,000 PHP together!</li>
              <li>Tongits Land – No Tandem Game！</li>
            </ul>
          </div>
<!--          <div class="download-box">-->
<!--            <a @click="downloadApp">-->
<!--              <img src="../assets/img/ic_googleplay.png" alt="">-->
<!--            </a>-->
<!--            <a @click="downloadApp">-->
<!--              <img src="../assets/img/ic_appstore.png" alt="">-->
<!--            </a>-->
<!--            <a @click="downloadApp">-->
<!--              <img src="../assets/img/ic_anzhuoplay.png" alt="download">-->
<!--            </a>-->
<!--            <a @click="downloadPc" style="text-decoration: underline; color: #FFF553">-->
<!--              Alternate Download-->
<!--            </a>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from 'wowjs';
import config from '@/config'
export default {
  name: "HomePage",
  data() {
    return {
    };
  },
  mounted() {
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    })
    wow.init();
  },
  methods: {
    downloadApp() {
      window.open(config.appDownLoadUrl.pc)
    },
    downloadPc() {
      window.open(config.appDownLoadUrl.local)
    }
  }
};
</script>
<style scoped>
/* 整体盒子 */
#HomePage {
  width: 100%;
}
.img-responsive {
  max-height: 711px;
  padding-top: 25px;
}

/* downLoad */
#downLoad {
  /* max-height: 750px; */
  padding: 50px 100px 20px 100px;
  transition: all ease 0.6s;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.downLoad-container{
  width: 100%;
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.downLoad-container:first-child img{
  float: right;
}
#downLoad .downLoad-title {
  padding-bottom: 10px;
  /* border-bottom: 1px solid #ccc; */
  color: #FFF553;
  font-size: 42px;
}
.download-ul {
  padding-left: 20px;
  list-style-image: url(../assets/img/list_img.png);
}
#downLoad li {
  font-size: 20px;
  color: #fff;
  line-height: 30px;
  margin-top: 7px;
}
#downLoad .downLoad-device {
  margin: 50px 0 20px;
}
.download-box a {
  display: flex;
  margin-top: 20px;
  /* max-width: 300px; */
}
.download-box a img {
  max-width: 300px;
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #swiper {
    height: 200px;
  }
  #downLoad {
    padding: 30px;
  }
  .downLoad-container{
    margin-top: 50px;
    flex-direction: column;
  }
  .slideInLeft {
    display: flex;
    justify-content: center;
  }
  .img-responsive {
    margin-left: 0;
    max-height: 520px;
  }
  #downLoad .downLoad-title {
    font-size: 30px;
    text-align: center;
  }
  #downLoad li {
    line-height: 20px;
    margin-bottom: 15px;
  }
  #downLoad .downLoad-device {
    font-size: 18px;
    margin: 10px 0 10px;
  }
  .download-intro {
    display: flex;
    flex-direction: column;
  }
  .download-intro li {
    font-size: 18px!important;
  }
  .download-box{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .download-box a:last-child {
    margin-bottom: 30px;
  }
  .download-box a img{
    max-width: 300px;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 400px;
  }
  .slideInLeft {
    margin-left: 0;
    display: flex;
    justify-content: center;
  }
  .img-responsive {
    margin-left: 0;
    max-height: 520px;
  }
  #downLoad {
    padding: 60px;
  }
  .downLoad-container{
    flex-direction: column;
  }
  #downLoad .downLoad-title {
    font-size: 60px;
    text-align: center;
  }
  #downLoad .downLoad-device {
    font-size: 60px;
    margin: 30px 0 15px;
  }
  #downLoad li {
    margin-bottom: 15px;
  }
  .download-intro {
    display: flex;
    flex-direction: column;
  }
  .download-intro li {
    font-size: 30px!important;
    line-height: 30px!important;
  }
  .download-box{
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .download-box a:last-child {
    margin-bottom: 30px;
  }
  .download-box a img{
    max-width: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/HomePage.vue